module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Accent.cf7bb40d.jpg";